import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame", "circle", "input"];
  static classes = [
    "enabled",
    "enabledTranslate",
    "disabled",
    "disabledTranslate",
  ];

  connect() {
    if (this.getToggledValue()) {
      this.setEnabled();
    } else {
      this.setDisabled();
    }
  }

  toggle() {
    if (this.getToggledValue()) {
      this.setToggledValue("false");
      this.setDisabled();
    } else {
      this.setToggledValue("true");
      this.setEnabled();
    }
  }

  setEnabled() {
    this.frameTarget.classList.add(this.enabledClass);
    this.frameTarget.classList.remove(this.disabledClass);
    this.circleTarget.classList.add(this.enabledTranslateClass);
    this.circleTarget.classList.remove(this.disabledTranslateClass);
  }

  setDisabled() {
    this.frameTarget.classList.remove(this.enabledClass);
    this.frameTarget.classList.add(this.disabledClass);
    this.circleTarget.classList.remove(this.enabledTranslateClass);
    this.circleTarget.classList.add(this.disabledTranslateClass);
  }

  getToggledValue() {
    var toggledValue = false;
    this.inputTargets.forEach((element, _) => {
      if (element.value == "true") {
        toggledValue = true;
      }
    });
    return toggledValue;
  }

  setToggledValue(value) {
    this.inputTargets.forEach((element, _) => {
      element.value = value;
    });
  }
}
